<script>
import options from "./NykInput.options"
export default options
</script>

<template>
  <div
    class="nyk-form-element"
    :class="{
      'nyk-form-element--validation-failed': hasValidationError,
      'nyk-form-element--prefix': prefix,
    }"
    :style="backgroundColor ? { '--nyk-input-background-color': backgroundColor } : undefined">
    <div class="nyk-form-element__content">
      <input :ref="el => inputElement = el"
        :id="name"
        :name="name"
        :type="type"
        :inputmode="inputMode"
        class="nyk-form-element__content__input"
        :aria-describedby="hasValidationError && errorMessage ? `description-${name}-error` : `description-${name}`"
        :aria-invalid="hasValidationError"
        :aria-required="required"
        :invalid="hasValidationError"
        :required="required"
        :autocomplete="autoComplete"
        :maxlength="maxLength"
        :placeholder="label"
        :value="value"
        v-bind="attributes"
        v-on="validationListeners"
        @input.prevent.stop="onInputChange"
        @select.prevent.stop
        @focus="onFocus"
        @blur.prevent.stop="onBlur"
        @invalid.prevent.stop="onInvalid">
      <label :for="name" class="nyk-form-element__content__label">{{ label }}</label>
      <span v-if="prefix" class="nyk-form-element__content__prefix">{{ prefix }}</span>
      <button @click="resetInputValue" type="button" class="nyk-form-element__content__reset-icon" :aria-label="clearButtonAriaLabel">
        <span class="nyk-icon nyk-icon--ui-close"></span>
      </button>
      <div v-if="hasValidationError" class="nyk-form-element__content__error-icon">
          <span class="nyk-icon nyk-icon--ui-form-error"></span>
      </div>
    </div>
    <span class="nyk-form-element__help-message" :id="`description-${name}`">{{ description }}</span>
    <span v-if="hasValidationError && errorMessage" class="nyk-form-element__error-message" :id="`description-${name}-error`" aria-live="polite">{{ errorMessage }}</span>
  </div>
</template>